@if (showPicture()) {
  <img
    class="ProfilePicture-img rounded-circle"
    [src]="src()"
    [attr.width]="size()"
    [attr.height]="size()"
    [attr.alt]="alt() ? alt() : (altTranslationKey() | translate)"
    loading="lazy"
    decoding="async"
    (error)="failedSrc.set(src())" />
} @else {
  <app-default-avatar shape="circle" [name]="alt()" [size]="size()" fallbackIcon="person_outline" />
}
